import Fade from '@material-ui/core/Fade';
import MUIMenuHover from 'material-ui-popup-state/HoverMenu';

import { withStyles } from '@material-ui/core/styles';
import MUIMenu, { MenuProps } from '@material-ui/core/Menu';
import MUIMenuItem from '@material-ui/core/MenuItem';

import { style } from '../../api';

const menuDefaultProps: Partial<MenuProps> = {
  TransitionComponent: Fade,
  elevation: 0,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
};

const menuStyles = {
  paper: {
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: 0,
    minWidth: 127,
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
  },
};

const Menu = withStyles(menuStyles)(MUIMenu);

Menu.defaultProps = menuDefaultProps;

const MenuHover = withStyles(menuStyles)(MUIMenuHover);

MenuHover.defaultProps = menuDefaultProps;

const MenuItem = withStyles(() => ({
  root: {
    justifyContent: 'space-between',
    padding: '8px 14px',
    '& span': {
      fontSize: 14,
      color: style.black_new,
      lineHeight: 'initial',
    },

    '& svg': {
      marginLeft: 16,
      width: 14,
      height: 14,
    },
  },
}))(MUIMenuItem);

// type MenuItemProps = Partial<MUIMenuItemProps> & { disableAutoClose?: boolean };

// const MenuItem: MenuItemInterface<MenuItemProps> = ({
//   disableAutoClose = false,
//   ...props
// }) => {
//   const popupState = useMenuContext();

//   const onClick = (event: never) => {
//     // Auto close menu
//     if (!disableAutoClose) {
//       popupState.close();
//     }

//     props?.onClick?.(event);
//   };

//   return <StyledMenuItem {...props} onClick={onClick} />;
// };

export { Menu, MenuHover, MenuItem };
